import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import {
  ROUTE_FRANCHISE_MANAGER_WORK_ORDERS,
  ROUTE_FLEET_DASHBOARD,
  ROUTE_DRIVER,
} from '../util/constants';

interface RequireCustomerProps {
  children: JSX.Element;
}

export default function RequiredCustomer({
  children,
}: RequireCustomerProps) {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const location = useLocation();

  if (currentUser.roles?.includes('fleet_driver')
  && !currentUser.roles?.includes('fleet_manager')) {
    return <Navigate to={ROUTE_DRIVER} />;
  }

  if (currentUser.roles?.includes('fleet_manager')) {
    return (
      <Navigate
        to={ROUTE_FLEET_DASHBOARD}
        state={{ from: location }}
      />
    );
  }

  if (currentUser.roles?.includes('manager')
  || currentUser.roles?.includes('technician')
  || currentUser.roles?.includes('tester')
  || currentUser.roles?.includes('sales')) {
    return (
      <Navigate
        to={ROUTE_FRANCHISE_MANAGER_WORK_ORDERS}
        state={{ from: location }}
      />
    );
  }

  return children;
}
